import type { IBrandOpsContract } from '../../../redux/brandOps/types';

/** Generic MSA-style preview generated from contract fields (client-side). */
export function generateContractLegalPreview(fields: Partial<IBrandOpsContract> & { brandName?: string }): string {
    const brand = fields.brandName || 'the Brand';
    const fee = fields.fee != null ? `${fields.currency || 'USD'} ${Number(fields.fee).toLocaleString()}` : '[fee]';
    const cadence = fields.cadence || '[cadence]';
    const deliverables = fields.deliverables || '[deliverables]';
    const threshold = fields.missed_post_threshold ?? 2;
    const scopes = (fields.clearance_scopes || []).join(', ') || 'standard content clearance';
    const approval = fields.require_brand_approval
        ? 'All scheduled posts require Brand approval before publish.'
        : 'Manager may publish within the approved content guidelines without per-post Brand approval.';

    return [
        `MASTER SERVICES AGREEMENT — CONTENT OPERATIONS`,
        ``,
        `This agreement is between ${brand} ("Brand") and the Content Operations Manager ("Manager").`,
        ``,
        `1. SERVICES. Manager will provide content operations services including planning, drafting, scheduling, and publishing social content as described: ${deliverables}.`,
        ``,
        `2. COMPENSATION. Brand shall pay Manager ${fee} on a ${cadence} basis, subject to escrow release rules and strike policy.`,
        ``,
        `3. MISSED POSTS. More than ${threshold} missed scheduled posts in a billing period may trigger a strike and delay escrow release.`,
        ``,
        `4. CLEARANCE. Manager warrants deliverables are cleared for: ${scopes}.`,
        ``,
        `5. APPROVAL. ${approval}`,
        ``,
        `6. TERM. This agreement remains in effect until terminated by either party in writing or voided for material breach.`,
        ``,
        `7. SIGNATURE. Electronic signature (typed name + drawn signature) constitutes acceptance of these terms.`,
    ].join('\n');
}
